module.exports = __webpack_public_path__ + "img/gd_image.066659f7.png";